import CurriculumCard from "./CurriculumCard";
import PropTypes from "prop-types";

const CurriculumCards = ({ curriculum_view }) => {
  const curriculum = [
    {
      day: "1",
      title: "Introduction to virtual assistance",
      subtitles: [
        "Soft skills required to be an assistant",
        "Hard skills required to be an assistant",
        "Making the most of working virtually",
      ],
    },
    {
      day: "2",
      title: "LEARNING THE SKILL",
      subtitles: [
        "Time Management",
        "Prioritization",
        "Meeting Scheduling",
        "Note Taking",
      ],
    },
    {
      day: "3",
      title: "LEARNING THE SKILL 2",
      subtitles: [
        "Reporting",
        "Documentation and Filing",
        "Organization",
        "Travel Arrangements",
      ],
    },
    {
      day: "4",
      title: "INTRODUCTION TO PRODUCTIVITY SOFTWARE AND APPS",
      subtitles: [
        "Productivity softwares",
        "Appointment Scheduling app",
        "Collaboration Apps",
      ],
    },
    {
      day: "5",
      title: "INTRODUCTION TO COMMUNICATION",
      subtitles: [
        "Types Of Communication",
        "Deciding communication tools as a Virtual Assistant",
        "Phone and Email etiquette",
      ],
    },
    { day: "6", title: "Writing Workshop" },
    {
      day: "7",
      title: "CONTENT CREATION",
      subtitles: [
        "Creative Writing",
        "Search Engine Optimization (SEO)",
        "Social Media Management",
        "Graphic Design",
      ],
    },
    {
      day: "8",
      title: "BEING YOUR BEST AS A VA -1",
      subtitles: [
        "Client Onboarding",
        "Stakeholder Management",
        "Building Trust (Discretion and Confidentiality)",
      ],
    },
    {
      day: "9",
      title: "BEING YOUR BEST AS A VA -2",
      subtitles: [
        "Emotional Intelligence",
        "Stress Management",
        "Conflict Management",
      ],
    },
    { day: "10", title: "CRITICAL THINKING AND RESOURCEFULNESS" },
    {
      day: "11",
      title: "PROACTIVE THINKING AND DECISION MAKING",
      subtitles: ["Effective decision making"],
    },
    { day: "12", title: "LEVERAGING BEING AN EA TO LEAPFROG YOUR CAREER" },
  ];

  return (
    <div className="grid xl:grid-cols-2 2xl:grid-cols-3 justify-items-center">
      {curriculum.map((day, i) => {
        return i <= curriculum_view - 1 ? (
          <CurriculumCard key={i} curriculum={day} />
        ) : (
          ""
        );
      })}
    </div>
  );
};

CurriculumCards.propTypes = {
  curriculum_view: PropTypes.number,
}

export default CurriculumCards;
